import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { SupervisorApprovalsPage } from '@/features/leave/pages/SupervisorApprovalsPage'

export const Route = createFileRoute('/_authenticated/leave/approvals')({
  validateSearch: z.object({
    requestId: z.coerce.number().optional(),
    openDialog: z
      .union([z.boolean(), z.enum(['true', 'false'])])
      .optional()
      .transform(v => v === true || v === 'true'),
  }),
  component: SupervisorApprovalsPage,
})
